import * as React from 'react';
import { ITEM_WIDTH_OVER_XL, ITEM_WIDTH_SP, VerticalListArrows, } from '@lean-body/components/molecules/vertical_list_arrows';
import { PlaylistComponentSquare } from '../molecules/playlist_component_square';
import { PlaylistComponentLandscapeImg } from '../molecules';
export const PlaylistComponentCarousel = ({ playlists, classObject, itemMarginRight, itemsPadding, addFavoriteProgram, unFavoriteProgram, isMin, isLandscapeImg, }) => {
    const addFavorite = (playlist) => {
        playlist.isFavorited = true;
        addFavoriteProgram(playlist.id);
    };
    const unFavorite = (playlist) => {
        playlist.isFavorited = false;
        unFavoriteProgram(playlist.id);
    };
    return (React.createElement(VerticalListArrows, { classObject: classObject, itemsPadding: itemsPadding, itemMarginRight: itemMarginRight, itemSize: isMin ? ITEM_WIDTH_SP : ITEM_WIDTH_OVER_XL, items: playlists.map((v) => (React.createElement(React.Fragment, null, isLandscapeImg ? (React.createElement(PlaylistComponentLandscapeImg, { playlist: v, addFavoriteProgram: () => addFavorite(v), unFavoriteProgram: () => unFavorite(v) })) : (React.createElement(PlaylistComponentSquare, { playlist: v, addFavoriteProgram: () => addFavorite(v), unFavoriteProgram: () => unFavorite(v), isMin: isMin }))))) }));
};
